export default class PdpAddToCartBtn extends React.Component {
    constructor(props) {
        super(props);
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }

    handleKeyPress(event) {
        // Moving handle keypress here so that the render is clean below. We need this condition created for accessibility reasons 
        // otherwise tab functionality gets stuck on the increment couter not allowing keyboard user to pass. (W2O-3695)
        if (event.charCode === 13) {
            // We need this preventDefault event on the increment counter to fix a bug in which the counter increments twice W2O-3624
            event.preventDefault();
        }
    }

    render() {
        return (
            <div className="showDesktop">
                <div className="pdp-error-display alert alert-danger alert-dismissible hidden pdplanding-error" role="alert">
                    <span className="p1 bold alert-message"></span>
                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">{this.props.DismissText}</button>
                </div>
                <div className="AddBtnWrapper">
                    <div className="handle-counter">
                        <button type="button" className="btn counter-minus" aria-label="remove quantity" onKeyPress={this.handleKeyPress} onClick={(e) => { e.preventDefault(); this.props.decreaseCounter(); }} disabled={this.props.count == 1 ? "disbaled" : ""}>-</button>
                        <input type="text" className="quantityinput" aria-label="item-count" readOnly={true} value={this.props.count} />
                        <button type="button" className="btn counter-plus" aria-label="add quantity" onKeyPress={this.handleKeyPress} onClick={(e) => { e.preventDefault(); this.props.increaseCounter(); }} disabled={this.props.count >= this.props.AllowedMaxQuantity ? "disbaled" : ""}>+</button>
                    </div>
                    {this.props.CartItem == null ?
                        <button type="button" className="btn btn-primary btn-lg btn-add-cart" data-choice-id={this.props.dataChoiceAttributeIds} data-alcohol={this.props.isAlcohol} onClick={() => this.props.addToCart()}>Add To Bag - ${this.props.getPrice()}</button>
                        :
                        <button type="button" className="btn btn-primary btn-lg btn-add-cart" data-choice-id={this.props.dataChoiceAttributeIds} data-alcohol={this.props.isAlcohol} onClick={() => this.props.addToCart()}>Update - ${this.props.getPrice()}</button>
                    }
                </div>
            </div>
        )
    }
}
